import { CURRENT_USER_KEY, KEY_PREFIX, STORE_NAME } from '@/data/forReactAndMobile/constants';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

const currentUserKey = `${KEY_PREFIX}${
	process.env.NEXT_PUBLIC_REACT_APP_ROUTER_BASENAME || ''
}-${STORE_NAME}-${CURRENT_USER_KEY}`;
const REFRESH_EXCLUDED_PATHS = ['/checkout'];

const StorageSync = () => {
	const router = useRouter();

	useEffect(() => {
		const handler = (event: StorageEvent) => {
			if (event.key !== currentUserKey) return;

			const currentPath = window.location.pathname;
			if (REFRESH_EXCLUDED_PATHS.some((path) => currentPath.startsWith(path))) return;

			router.refresh();
		};

		window.addEventListener('storage', handler);
		return () => window.removeEventListener('storage', handler);
	}, [router]);

	return null;
};

export default StorageSync;
